import Vue from 'vue';
import {
    GET_STORE_CARD_LIST_REQUEST,
    GET_STORE_CARD_LIST_SUCCESS,
    GET_STORE_CARD_LIST_FAILURE
} from '../mutationTypes';

const state = {
    loading: false,
    list: [],
    pageCount: 0,
};
const mutations = {
    [GET_STORE_CARD_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_STORE_CARD_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count || 0;
        state.list = res.cardData || [];
    },
    [GET_STORE_CARD_LIST_FAILURE](state) {
        state.loading = false;
    },
};

export const actions = {
    async getStoreCardList({ commit }, query) {
        commit(GET_STORE_CARD_LIST_REQUEST);
        const res = await Vue.$ajax.get('storeCardList', query);

        if (!res.errorType) {
            commit(GET_STORE_CARD_LIST_SUCCESS, res);
        } else {
            commit(GET_STORE_CARD_LIST_FAILURE);
        }
    }
};

export default {
    state,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/cardList.js